import { render } from "./StatusesListEditModal.vue?vue&type=template&id=53d74396"
import script from "./StatusesListEditModal.vue?vue&type=script&lang=js"
export * from "./StatusesListEditModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__